/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface OrganizationAvatar
 */
export interface OrganizationAvatar {
  /**
   *
   * @type {string}
   * @memberof OrganizationAvatar
   */
  url?: string | null
}

export function OrganizationAvatarFromJSON(json: any): OrganizationAvatar {
  return OrganizationAvatarFromJSONTyped(json, false)
}

export function OrganizationAvatarFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationAvatar {
  if (json === undefined || json === null) {
    return json
  }
  return {
    url: !exists(json, 'url') ? undefined : json['url']
  }
}

export function OrganizationAvatarToJSON(value?: OrganizationAvatar | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    url: value.url
  }
}
